import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ButtonModule } from "@app/shared/button/button.module";
import { PageTitleModule } from "@app/shared/page-title/page-title.module";
import { PartnersSectionModule } from "@app/shared/partners-section/partners-section.module";
import { SellingPointSectionModule } from "@app/shared/selling-point-section/selling-point-section.module";
import { UnleashSectionModule } from "@app/shared/unleash-section/unleash-section.module";
import { TranslateModule } from "@ngx-translate/core";
import { UtilsModule } from "../../shared/utils/utils-module";
import { AndroidPartnerStoresComponent } from "./android-partner-stores.component";

const routes: Routes = [
    {
        path: "",
        component: AndroidPartnerStoresComponent,
    },
];

@NgModule({
    declarations: [AndroidPartnerStoresComponent],
    exports: [AndroidPartnerStoresComponent],
    imports: [RouterModule.forChild(routes), CommonModule, TranslateModule, ButtonModule, UtilsModule, PageTitleModule, SellingPointSectionModule, UnleashSectionModule, PartnersSectionModule],
})
export class AndroidPartnerStoresModule {}
